import React from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import MyCard from './../MyCard.js';
import Card from 'react-bootstrap/Card';


class EX3secondaire extends React.Component{
  render(){
    return(
      <div>
          <Alert variant="danger">
            <h3>
              Exercices pour le troisème année secondaire.
            </h3>
          </Alert>

          <Row>
              <MyCard
              title="Factorisation et développement: identité remarquable"
              ty="Exercice"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/dev_fac.pdf" />

              <MyCard
              title="Théorème de Thalès"
               ty="Exercice"
               color1="#80ff80"
               content=""
               fileUrl="/documents/file/pdf/2/exercice/thales.pdf" />

              <MyCard
              title="Les puissances"
              ty="Exercice"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/puiisances.pdf" />
          </Row>

          <Row>
              <MyCard
              title="Théorème de Pythagore"
              ty="Exercice"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/pythagore.pdf" />

              <MyCard
              title="Ordre et opération"
              ty="Exercice"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/ordre.pdf" />


              <MyCard
              title="Les racine carée"
              ty="Exercice"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/racine_carré.pdf" />
          </Row>



          <Row>
              <MyCard
              title="Le calculs trigonométrique"
              ty="Exercice"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/trigo.pdf" />

              <MyCard
              title="Triangles semblables et isométriques"
              ty="Exercice"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/triangles.pdf" />

              <MyCard
              title="Les angles centraux et angles inscrits"
              ty="Exercice"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/angle.pdf" />


          </Row>



          <Row>
              <MyCard
              title="Les vecteurs et translation"
              ty="Exercice"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/vec_trans.pdf" />


              <MyCard
              title="Les équations"
              ty="Exercice"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/equation_ineq.pdf" />

              <MyCard
              title="Le repère dans le plan"
              ty="Exercice"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/repere.pdf" />


          </Row>



          <Row>
              <MyCard
              title="Les fonction affine"
              ty="Exercice"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/fonction_affi.pdf" />

              <MyCard
              title="L'équation d'une droite"
              ty="Exercice"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/equ_droite.pdf" />


              <MyCard
              title="Les fonction linéaire"
              ty="Exercice"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/fonction_lin.pdf" />

          </Row>


          <Row>



              <MyCard
              title="Géométrie dans l’espace"
              ty="Exercice"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/volumes.pdf" />

              <MyCard
              title="Les statistique"
              ty="Exercice"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/propo.pdf" />


              <MyCard
              title="Les systèmes"
              ty="Exercice"
              color1="#80ff80"
              content=""
              fileUrl="/documents/file/pdf/2/exercice/systeme.pdf" />

          </Row>


      </div>
    );
  }
}

export default EX3secondaire;
